import {
  NodeTypeEnum,
  StorageDurationEnum,
  SuppliersProximityEnum,
  TypeOfSuppliersEnum,
  WeightOptionEnum,
} from '@shared/api/types';
import { nativeEnum, z } from 'zod';

export const supplyFlowSchema = z
  .object({
    name: z.string().optional(),
    typeOfSuppliers: z.union([
      nativeEnum(TypeOfSuppliersEnum),
      z.literal('international'),
    ]),
    type: z.literal('supply').default('supply'),
    originLocation: z.string().nullable().optional(),

    suppliersProximity: z.nativeEnum(SuppliersProximityEnum),

    weight: z.coerce.number({ invalid_type_error: 'Enter a number' }),
    weightOption: z.nativeEnum(WeightOptionEnum),
    coldChainPercentage: z.coerce
      .number({ invalid_type_error: 'Enter a number' })
      .min(0, 'Must be at least 0')
      .max(100, 'Must be at most 100'),
    segments: z.array(
      z.object({
        nodeName: z.string().min(1, 'Node name is required').optional(),
        nodeType: z.nativeEnum(NodeTypeEnum),
        distance: z.coerce.number().min(1, 'Distance must be at least 1'),
        transportMode: z.string().min(1, 'Transport mode is required'),
        storageDuration: z.nativeEnum(StorageDurationEnum),
      })
    ),
  })
  .superRefine((val, ctx) => {
    const { weightOption, weight } = val;
    if (weightOption !== WeightOptionEnum['total_weight'] && weight > 100) {
      ctx.addIssue({
        code: z.ZodIssueCode.too_big,
        path: ['weight'],
        maximum: 100,
        type: 'number',
        inclusive: true,
        message: 'Weight must be at most 100',
      });
    }
  });
